import './css/bootstrap.scss';

import * as React from 'react';
import { render } from 'react-dom';

import { Root } from './root';

const rootElement = document.getElementById('root');
render(<Root />, rootElement);
